import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-widget-box',
  templateUrl: './box.component.html',
  imports: [
    CommonModule,
  ]
})
export class WidgetBoxComponent {

  /**
   * Box name
   */
  name = input('');

  /**
   * Box description
   */
  description = input('');

  /**
   * Box icon
   */
  icon = input('');

  /**
   * Box color
   */
  color = input('');

  /**
   * Box dark mode
   */
  dark = input(false);
}
